/**
 * Gomme magique on desktop : the photo toolbar's "Gommer" (Photo.onMagicEraser → "magic-eraser"
 * → BaseMain) opens this, full screen : "Gommer un élément" and its "?" top left, "Fermer" top
 * right, the photo as its page crops it (only the cropped area, in a white frame), the hint under
 * it, then Tout effacer · Gommer la zone, Recommencer · Garder — the logic of the mobile
 * EditPhoto's erase mode, shared.magiceraser.EraseFlow. How it works (EraserTutorial) shows over
 * it the first times, and again with "?".
 *
 * "Garder" is final : the photo is replaced on the server and every place of the album showing it
 * follows (MagicEraserService.keep), then the popup closes.
 */
fx.ns("shared.popups", class MagicEraserPopup extends fx.components.Popup {

    constructor(component, model)
    {
        super(component);

        this.model = model;

        this.showClose = false;           // "Fermer" instead
        this.closeOnClickBehind = false;  // a click beside the photo must not drop the strokes

        // the whole window
        this.contentWidth = window.innerWidth;
        this.contentHeight = window.innerHeight;
        this._onResizeHandler = this._onResize.bind(this);
    }

    get HEADER_HEIGHT() { return 64; }
    get BAR_HEIGHT() { return 104; }
    get HINT_HEIGHT() { return 46; }
    get BUTTON_HEIGHT() { return 56; }

    create()
    {
        super.create();

        // the cropped area only : the view has the frame's size and clips the photo placed around it
        this.view = new shared.magiceraser.EraserView();
        this.addChild(this.view, { width : 0, height : 0, top : 0, left : 0 });

        this.frame = new fx.components.Box("frame");
        this.addChild(this.frame, { width : 0, height : 0, top : 0, left : 0 });

        let header = new fx.components.Box("header");
        this.title = new fx.components.Text({ className : "eraseTitle",
            text : fx.text("Gommer un élément") + '<span class="help" title="' + fx.text("Comment ça marche ?") + '">?</span>' });
        header.addChild(this.title, { width : 500, height : this.HEADER_HEIGHT, top : 0, left : 24 });
        this.closeButton = new fx.components.Button({ label : fx.text("Fermer"), className : "eraseClose" });
        header.addChild(this.closeButton, { width : 120, height : 40, top : 12, right : 24 });
        this.addChild(header, { width : "100%", height : this.HEADER_HEIGHT, top : 0, left : 0 });

        this.hint = new fx.components.Text({ text : "", className : "eraseHint" });
        this.addChild(this.hint, { width : "100%", height : this.HINT_HEIGHT, top : 0, left : 0 });

        this.bar = new fx.components.Box("eraseBar");
        let button = (label, className) => {
            let b = new fx.components.Button({ label : label, className : className });
            this.bar.addChild(b, { width : 240, height : this.BUTTON_HEIGHT, top : (this.BAR_HEIGHT - this.BUTTON_HEIGHT) / 2, left : 0 });
            return b;
        };
        this.buttons = {
            back : this.closeButton,      // off while the erase runs, like the mobile "< Retour"
            clear : button(fx.text("Tout effacer"), "clear"),
            run : button(fx.text("Gommer la zone"), "primary"),
            cancel : button(fx.text("Annuler"), "cancel"),
            retry : button(fx.text("Recommencer"), "retry"),
            keep : button(fx.text("Garder"), "primary"),
        };
        this.addChild(this.bar, { width : "100%", height : this.BAR_HEIGHT, bottom : 0, left : 0 });

        // over everything but the bar
        this.tutorial = new shared.magiceraser.EraserTutorial();
        this.addChild(this.tutorial, { width : "100%", height : 0, top : 0, left : 0 });
    }

    onReady()
    {
        super.onReady();

        this.flow = new shared.magiceraser.EraseFlow({
            view : this.view,
            hint : this.hint,
            buttons : this.buttons,
            component : this.data,
            model : this.model,
            onLayout : () => this._layoutBar(),
            onKept : () => this.close(),
        });

        this.on("click", this._onClose, this.closeButton);
        this.on("click", this._onHelp, this.title);
        window.addEventListener("resize", this._onResizeHandler);
        this.on("click", this._onClear, this.buttons.clear);
        this.on("click", this._onRun, this.buttons.run);
        this.on("click", this._onCancel, this.buttons.cancel);
        this.on("click", this._onRetry, this.buttons.retry);
        this.on("click", this._onKeep, this.buttons.keep);

        let media = this.model.photos.find({ id : this.data.content });

        this._layout();
        this.flow.start(media);

        // the screen first, the tutorial a second later
        this.delay(this._openTutorial, this.TUTORIAL_DELAY);
    }

    get TUTORIAL_DELAY() { return 1000; }

    // asked only now, so a popup closed within the second leaves the tutorial unseen
    _openTutorial()
    {
        if (this.flow && shared.magiceraser.EraserTutorial.shouldOpen(this.model.account))
            this.tutorial.open();
    }

    onDisplayUpdated()
    {
        super.onDisplayUpdated();

        this._layout();
    }

    destroy()
    {
        window.removeEventListener("resize", this._onResizeHandler);

        // the brush listens on window : closing must not leave it behind
        if (this.flow)
            this.flow.stop();

        this.flow = null;

        super.destroy();
    }

    // ---- events

    _onClose()
    {
        if (this.flow && !this.flow.busy)
            this.close();
    }

    // the "?" beside the title
    _onHelp(e)
    {
        if (e.target.closest(".help"))
            this.tutorial.open();
    }

    // full screen it stays
    _onResize()
    {
        if (this.contentWidth != window.innerWidth)
            this.contentWidth = window.innerWidth;

        if (this.contentHeight != window.innerHeight)
            this.contentHeight = window.innerHeight;
    }

    _onClear()  { if (this.flow) this.flow.clear(); }
    _onRun()    { if (this.flow) this.flow.run(); }
    _onCancel() { if (this.flow) this.flow.cancel(); }
    _onRetry()  { if (this.flow) this.flow.retry(); }
    _onKeep()   { if (this.flow) this.flow.keep(); }

    // ---- layout

    // 240 px a button, 260 for "Gommer la zone"
    _layoutBar()
    {
        if (this.flow)
            this.flow.layoutBar(this.contentWidth, (this.BAR_HEIGHT - this.BUTTON_HEIGHT) / 2, this.BUTTON_HEIGHT, 240,
                                { gap : 20, widthOf : (button) => button == this.buttons.run ? 260 : 240 });
    }

    /**
     * The photo as its page shows it : the component's frame fitted in the room between the header
     * and the hint, the view that size and clipping, the whole photo placed in it by x_inner /
     * y_inner / width_inner / height_inner (component units) — the mask still covers the whole
     * photo, only the cropped area is on show and can be drawn on. A photo turned inside its frame
     * is shown whole instead : an upright picture cannot lie over a turned one.
     */
    _layout()
    {
        if (!this.view || !this.view.initialized)
            return;

        let W = this.contentWidth;
        let H = this.contentHeight;
        let top = this.HEADER_HEIGHT + 8;
        let gap = 16;
        let room = { width : W - 80, height : H - top - this.BAR_HEIGHT - gap - this.HINT_HEIGHT };
        let d = this.data;
        let turned = Number(d.rotation_inner || 0) != 0;
        let slider = this.view.SLIDER_ROOM;   // under the photo in the view, unused here

        this.tutorial.viewport({ width : W, height : H - this.BAR_HEIGHT, top : 0, left : 0 });

        if (turned || !d.width || !d.height || !d.width_inner || !d.height_inner)
        {
            this.frame.visible = false;
            this.view.viewport({ width : room.width, height : room.height + slider, top : top, left : 40 });
            this.view.updateDisplay();
            this.view.place(null);
            this.hint.viewport({ width : W, height : this.HINT_HEIGHT, top : top + room.height + gap, left : 0 });
            this._layoutBar();
            return;
        }

        // the photo and its hint centred together
        let scale = Math.min(room.width / d.width, room.height / d.height);
        let frame = { width : Math.round(d.width * scale), height : Math.round(d.height * scale) };
        frame.left = Math.round((W - frame.width) / 2);
        frame.top = Math.round(top + (room.height - frame.height) / 2);

        this.view.viewport({ width : frame.width, height : frame.height + slider, top : frame.top, left : frame.left });
        this.view.updateDisplay();
        this.view.place({ left : Number(d.x_inner || 0) * scale, top : Number(d.y_inner || 0) * scale,
                          width : d.width_inner * scale, height : d.height_inner * scale });

        this.frame.viewport({ width : frame.width, height : frame.height, top : frame.top, left : frame.left });
        this.frame.visible = true;
        this.frame.updateDisplay();

        this.hint.viewport({ width : W, height : this.HINT_HEIGHT, top : frame.top + frame.height + gap, left : 0 });
        this._layoutBar();
    }
});
